import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { endExpiredSession, isSessionExpired } from '../../utils/auth';

export default function RequireAuth({ children }: { children: ReactNode }) {
    const location = useLocation();
    const hasToken = !!localStorage.getItem('token');
    const expired = isSessionExpired();

    // A tab left open overnight: when the user comes back to it, check the
    // login before they try to use a page that can no longer load anything.
    useEffect(() => {
        const checkOnReturn = () => {
            if (document.visibilityState === 'visible' && isSessionExpired()) endExpiredSession();
        };
        document.addEventListener('visibilitychange', checkOnReturn);
        window.addEventListener('focus', checkOnReturn);
        return () => {
            document.removeEventListener('visibilitychange', checkOnReturn);
            window.removeEventListener('focus', checkOnReturn);
        };
    }, []);

    if (!hasToken) {
        return <Navigate to='/login' replace state={{ from: location }} />;
    }
    if (expired) {
        // The stale token is replaced on the next successful login.
        return <Navigate to='/login?expired=1' replace state={{ from: location }} />;
    }

    return children;
}
